import PropTypes from 'prop-types';

import Toast from '#globalComponents/Toast/Toast';
import { useErrorStore } from '#lib/stores/errorStore';

export const useError = () => useErrorStore();

export const ErrorProvider = ({ children }) => {
	const notification = useErrorStore((s) => s.notification);
	const closeNotification = useErrorStore((s) => s.closeNotification);

	return (
		<>
			{children}
			{notification && (
				<Toast
					type={notification.type}
					title={notification.title}
					message={notification.message}
					actionButton={notification.actionButton}
					autoClose={notification.autoClose}
					autoCloseDuration={notification.autoCloseDuration}
					onClose={closeNotification}
				/>
			)}
		</>
	);
};

ErrorProvider.propTypes = {
	children: PropTypes.node.isRequired,
};
